import { EstablishmentServiceMock } from "./establishment.types";

export const mockEstablishmentService = (): EstablishmentServiceMock => ({
  fetchEstablishments: jest.fn(),
});
